import {ApiService, GetListResponse, ModelBase} from './api.service';
import {Injectable} from '@angular/core';

export interface Customer extends ModelBase {
  name: string;
  address_1: string;
  address_2: string;
  country: string;
  phone: string;
  purchase_date: string;
  sma_expire_date: string;
  primary_contact: string;
  secondary_contact: string;
  comment: string;
  default_openlab_system_id?: number;
  default_openlab_system?: any;
  default_aic_version_name?: string;
  ac_count: number;
  user_count: number;
  server_count: number;
  is_system: boolean;
  account_id_ett: string;
  system_handle_ett: string;
  customer_name_ett: string;
  location_ett: string;
}

interface GetCustomersArguments {
  offset: number;
  limit: number;
  include_default_ols: boolean;
}

interface GetCustomersResponse extends GetListResponse {
  customers: Customer[];
}

// any set of characters with no trailing spaces
export const customerNamePattern = /^(?! ).*(?<! )$/

@Injectable({
  providedIn: 'root'
})
export class CustomerApiService {

  public static SYSTEM_CUSTOMER_ID = 0;

  constructor(
    private apiService: ApiService
  ) {}

  public async getCustomers(
    args: GetCustomersArguments
  ): Promise<GetCustomersResponse> {
    const { offset, limit, include_default_ols } = args;
    return this.apiService.getResponseJson({
      urlPart: '/customers',
      queryStringParams: {
        offset: offset,
        limit: limit,
        include_default_ols: include_default_ols
      }
    });
  }

  public async getCustomer(
    args: { customerId: number }
  ): Promise<{ customer: Customer }> {
    const { customerId } = args;
    return this.apiService.getResponseJson({
      urlPart: `/customers/${customerId}`
    });
  }

  public async createCustomer(
    args: { customer: Customer }
  ): Promise<{ customer: Customer }> {
    const { customer } = args;
    return this.apiService.getResponseJson({
      urlPart: `/customers/new`,
      method: 'POST',
      data: customer
    });
  }

  public async updateCustomer(
    args: { customer: Customer, reason: string }
  ): Promise<{ customer: Customer }> {
    const { customer, reason } = args;
    return this.apiService.getResponseJson({
      urlPart: `/customers/${customer.id}`,
      method: 'PUT',
      data: {
        customer: customer,
        reason: reason
      }
    });
  }

  public async deleteCustomer(
    args: { customer: Customer, reason: string }
  ): Promise<{ customer: Customer }> {
    const { customer, reason } = args;
    return this.apiService.getResponseJson({
      urlPart: `/customers/${customer.id}`,
      method: 'DELETE',
      data: {
        reason: reason
      }
    });
  }

}
